import { backendApi } from "./axios";
import { EXAM_RESULT_ENDPOINTS, STUDENT_CLASS_ENDPOINTS, STUDENT_ENDPOINTS, STUDENT_NOTE_ENDPOINTS } from "./endpoints";

/**
 * @param {string} studentId - ID of the student
 * @param {object} payload - profile data
 */
export function updateProfile(payload) {
  return backendApi.put(STUDENT_ENDPOINTS.PROFILE_UPDATE, payload);
}

export function getProfile() {
  return backendApi.get(STUDENT_ENDPOINTS.GET_PROFILE);
}

export function getStudentLimits() {
  return backendApi.get(STUDENT_ENDPOINTS.GET_LIMITS);
}

export function updateEmail(data) {
  return backendApi.put(STUDENT_ENDPOINTS.UPDATE_EMAIL, data);
}

export function sendStudentInvitation(email) {
  return backendApi.post(STUDENT_ENDPOINTS.INVITE.replace(':email', encodeURIComponent(email.trim())));
}

export function publicProfile(studentId) {
  return backendApi.get(
    STUDENT_ENDPOINTS.PUBLIC_PROFILE.replace(":studentId", studentId)
  );
}

export function publicEnrolledTutors(studentId) {
  return backendApi.get(
    STUDENT_ENDPOINTS.PUBLIC_ENROLLED_TUTORS.replace(":studentId", studentId)
  );
}

export function getSchedule() {
  return backendApi.get(STUDENT_CLASS_ENDPOINTS.SCHEDULES);
}

export function requestAClass(payload) {
  return backendApi.post(STUDENT_CLASS_ENDPOINTS.REQUEST_A_CLASS, payload);
}

export function checkConflicts(payload) {
  return backendApi.post(STUDENT_CLASS_ENDPOINTS.CHECK_CONFLICTS, payload);
}

export function checkConflictsWithOtherStudents(payload) {
  return backendApi.post(STUDENT_CLASS_ENDPOINTS.CHECK_CONFLICTS_OTHERS, payload);
}

export function fetchToBeConfirmed() {
  return backendApi.get(STUDENT_CLASS_ENDPOINTS.FETCH_TO_BE_CONFIRMED);
}

export function acceptSchedule(classId) {
  return backendApi.put(STUDENT_CLASS_ENDPOINTS.ACCEPT_SCHEDULE.replace(':classId', classId));
}

export function rejectSchedule(classId) {
  return backendApi.put(STUDENT_CLASS_ENDPOINTS.REJECT_SCHEDULE.replace(':classId', classId));
}

export function getUnconfirmedCompletedClasses() {
  return backendApi.get(STUDENT_CLASS_ENDPOINTS.UNCONFIRMED_COMPLETED_CLASSES);
}

export function confirmCompletedClass(instanceId) {
  return backendApi.patch(STUDENT_CLASS_ENDPOINTS.CONFIRM_COMPLETED_CLASS.replace(':instanceId', instanceId));
}

export function fetchEnrolledTutors() {
  return backendApi.get(STUDENT_CLASS_ENDPOINTS.ENROLLED_TUTORS);
}

export function fetchClassesByTutor(tutorId) {
  return backendApi.get(STUDENT_CLASS_ENDPOINTS.CLASSES_BY_TUTOR.replace(':tutorId', tutorId));
}

export function fetchPreviousClassesByTutor(tutorId) {
  return backendApi.get(STUDENT_CLASS_ENDPOINTS.PREVIOUS_CLASSES_BY_TUTOR.replace(':tutorId', tutorId));
}

export function fetchClassInstanceDetails(classInstanceId) {
  return backendApi.get(STUDENT_CLASS_ENDPOINTS.CLASS_INSTANCE_DETAILS.replace(':classInstanceId', classInstanceId));
}

export function cancelClassInstance(instanceId, payload = {}) {
  return backendApi.patch(
    STUDENT_CLASS_ENDPOINTS.CANCEL_CLASS_INSTANCE.replace(':instanceId', instanceId),
    payload
  );
}

export function endAllClassesByTutor(tutorId) {
  return backendApi.delete(STUDENT_CLASS_ENDPOINTS.CLASSES_BY_TUTOR.replace(':tutorId', tutorId));
}

export function classRescheduleRequest(payload) { 
  return backendApi.put(STUDENT_CLASS_ENDPOINTS.RESCHEDULE_CLASS, payload); 
} 

export function acceptRescheduleRequest(requestId) {
  return backendApi.put(STUDENT_CLASS_ENDPOINTS.ACCEPT_RESCHEDULE_REQUEST.replace(':requestId', requestId));
}

export function rejectRescheduleRequest(requestId) {
  return backendApi.put(STUDENT_CLASS_ENDPOINTS.REJECT_RESCHEDULE_REQUEST.replace(':requestId', requestId));
}

export function createNote(payload) {
  return backendApi.post(STUDENT_NOTE_ENDPOINTS.CREATE,payload);
}

export function updateNote(payload, noteId) {
  return backendApi.put(STUDENT_NOTE_ENDPOINTS.UPDATE.replace(':noteId', noteId),payload);
}

export function listNotes() {
  return backendApi.get(STUDENT_NOTE_ENDPOINTS.LIST);
}

export function listAiSummeries() {
  return backendApi.get(STUDENT_NOTE_ENDPOINTS.AI_SUMMARY);
}

export function listTranscripts() {
  return backendApi.get(STUDENT_NOTE_ENDPOINTS.AI_TRANSCRIPT);
}

export function deleteNote(noteId) {
  return backendApi.delete(STUDENT_NOTE_ENDPOINTS.DELETE.replace(':noteId', noteId));
}

export function checkNoteLimit() {
  return backendApi.get(STUDENT_NOTE_ENDPOINTS.CHECK_LIMIT);
}

export function createReview(payload) {
  return backendApi.post(STUDENT_CLASS_ENDPOINTS.CREATE_REVIEW,payload);
}

export function getExamResults(studentId) {
  return backendApi.get(EXAM_RESULT_ENDPOINTS.GET_ALL_BY_STUDENT.replace(':studentId', studentId));
}

export function preDeleteCheck() {
  return backendApi.get(STUDENT_ENDPOINTS.PRE_DELETE_CHECK);
}

export function deleteAccount(payload) {
  return backendApi.post(STUDENT_ENDPOINTS.DELETE_ACCOUNT, payload);
}